import { ITooltipProps } from "@edgetier/components";
import { TooltipProps } from "../tooltip";

export const MINIMUM_MULTIPLE_WIDTH = 600;
export const MINIMUM_SINGLE_WIDTH = 300;

export const MAXIMUM_TOOLTIP_ITEMS = 30;

export const MINIMUM_TAGS_TO_OPEN_ACCORDIONS = 11;

export const APPLY_BUTTON_TEXT = "Done";
export const CANCEL_BUTTON_TEXT = "Cancel";

export const LIMIT_REACHED_MESSAGE = "Item limit reached";

export const PLACEMENT_MAP: Record<Exclude<ITooltipProps["placement"], undefined>, TooltipProps["position"]> = {
    "bottom-start": "bottom-start",
    "bottom-end": "bottom-end",
    "bottom-center": "bottom",
    "top-start": "top-start",
    "top-center": "top",
    "top-end": "top-end",
    "left-end": "left-end",
    "left-center": "left",
    "left-start": "left-start",
    "right-end": "right-end",
    "right-center": "right",
    "right-start": "right-start",
    center: "top",
};
